import { observeScrollAnimation } from "common/utils/ui/visibility";
import "./print-technology-hero.scss";

const $getPrintTechnologyHeroElements = () =>
  document.querySelectorAll(".js-print-tech-hero-animate");

export default function initPrintTechnologyHero() {
  const $elements = $getPrintTechnologyHeroElements();
  observeScrollAnimation($elements);
}
